import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface ArchiveVendorModalProps {
    vendor: { id: string; name?: string | null } | null;
    isArchiving: boolean;
    onDismiss: () => void;
    onConfirmArchive: () => void;
}

export const ArchiveVendorModal = ({
    vendor,
    isArchiving,
    onDismiss,
    onConfirmArchive,
}: ArchiveVendorModalProps) => {
    const visible = Boolean(vendor?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, vendor?.id]);

    const vendorName = vendor?.name?.trim() || 'this vendor';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Archive vendor?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isArchiving}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isArchiving ? 'Archiving...' : 'Archive'}
                        buttonDisabled={isArchiving || !confirmReady}
                        buttonOnClick={onConfirmArchive}
                    />
                </div>
            }
        >
            <p>
                You are about to archive <strong>“{vendorName}”</strong>. It will be hidden from the
                vendor list.
            </p>
            <p>Service items that already use this vendor keep their vendor name.</p>
        </CustomModal>
    );
};
